import React, { FunctionComponent } from "react";
import { POST_TYPES, PostType, TOPICS, TopicKey } from "../../topics";
import { formatMinutes } from "../../data/format";

export interface TopicLabel {
  topic: TopicKey;
  long?: boolean;
}

export const TopicLabel: FunctionComponent<TopicLabel> = ({ topic, long }) => (
  <span
    className={`px-2 py-1 font-display text-label font-semibold uppercase ${TOPICS[topic].labelClass}`}
  >
    {long ? TOPICS[topic].name : TOPICS[topic].shortName}
  </span>
);

export interface PostMeta {
  topic?: TopicKey;
  longTopic?: boolean;
  type: PostType;
  readingTime?: number;
}

/** TopicLabel followed by the muted "Type · N min" TypeTag. */
export const PostMeta: FunctionComponent<PostMeta> = ({
  topic,
  longTopic,
  type,
  readingTime,
}) => (
  <div className="flex flex-wrap items-center gap-2 font-display text-label font-semibold uppercase">
    {topic && <TopicLabel topic={topic} long={longTopic} />}
    <span className="py-1 text-muted">
      {POST_TYPES[type].label}
      {readingTime !== undefined && ` · ${formatMinutes(readingTime)}`}
    </span>
  </div>
);
